<template>
    <div style="margin-left: 7px; margin-right: 7px">
        <div style="font-size: 13px" @click="topClick">

            <van-row>
                <van-col span="12">订单号：{{orderId}}</van-col>
                <van-col span="12" style="color: red;text-align: right">订单详情</van-col>
            </van-row>
            <div>下单时间：{{orderTime}}</div>
            <van-row>
                <van-col span="12">
                    <div>状态：
                        <span v-if="Number(validCode) < 15 || Number(validCode) >18" style="color: red">{{orderStatus}}</span>
                        <span v-else style="color: limegreen;">{{orderStatus}}</span>
                    </div>
                </van-col>
                <van-col span="12" style="text-align: right">
                    <div v-if="showEstimateFee" style="display: inline-flex">
                        预估总佣金：
                        <div v-if="Number(validCode) < 15 || Number(validCode) >18" style="color: red;">
                            ￥0
                            <span style="color:#999999;text-decoration:line-through;">￥{{totalEstimateFee}}</span>
                        </div>
                        <div v-else style="color: red;">￥{{totalEstimateFee}}</div>
                    </div>
                </van-col>
            </van-row>

        </div>
        <div style="margin-top: 8px" @click="bottomClick">
            <van-row>
                <van-col :span="left_span">
                    <Wp_image v-if="skuImg" :url="skuImg"></Wp_image>
                </van-col>
                <van-col :span="right_span" :style="{paddingLeft: right_padding_left, color: '#888888'}">
                    <div class="goods_name_div">{{goodsName}}</div>
                    <!--                <van-row>-->
                    <!--                    <van-col span="12"><div>状态：-->
                    <!--                        <span v-if="Number(validCode) < 15 || Number(validCode) >18" style="color: red">{{orderStatus}}</span>-->
                    <!--                        <span v-else style="color: limegreen;">{{orderStatus}}</span>-->
                    <!--                    </div></van-col>-->
                    <!--                    <van-col span="12" style="text-align: right">数量：x{{totalGoodsNum}}</van-col>-->
                    <!--                </van-row>-->
                    <div>总付款金额：<span style="color: rgba(255,0,0,0.6);">￥{{totalAmount}}</span></div>
                    <div v-if="showEstimateFee" style="display: inline-flex">
                        预估总佣金：
                        <div v-if="Number(validCode) < 15 || Number(validCode) >18" style="color: rgba(255,0,0,0.6);">
                            ￥0
                            <span style="color:#aaaaaa;text-decoration:line-through;">￥{{totalEstimateFee}}</span>
                        </div>
                        <div v-else style="color: rgba(255,0,0,0.6);">￥{{totalEstimateFee}}</div>
                    </div>
                    <div>数量：x{{totalGoodsNum}}</div>

                    <!--                <van-row>-->
                    <!--                    <van-col span="18">完成时间：{{finishTime}}</van-col>-->
                    <!--                    <van-col span="6" style="color: red;text-align: right">详情</van-col>-->
                    <!--                </van-row>-->
                </van-col>
            </van-row>
        </div>

    </div>
</template>

<script>
    import Wp_image from "./Wp_image";
    export default {
        name: "JdOrderInfoCard_With_Img",
        components: {Wp_image},
        props: {
            orderInfoData: {type: Object, default: null},
        },
        data(){
            return{
                goodsName: '商品名称',
                orderStatus: '订单状态',
                orderId: '订单号',
                totalAmount: 0,
                totalGoodsNum: '商品数量',
                totalEstimateFee: 0,
                orderTime: '',
                finishTime: '',
                validCode: '-1',
                pid: "",
                skuImg: "",
                left_span : 7,
                right_span: 17,
                right_padding_left: "8px",
                // ext1_user: "",
                showEstimateFee: true,
            }
        },
        created(){
            if(this.orderInfoData){
                this.goodsName = this.orderInfoData.goodsName;
                this.orderStatus = this.orderInfoData.orderStatus;
                this.orderId = this.orderInfoData.orderId;
                this.totalAmount = this.orderInfoData.totalAmount;
                this.totalGoodsNum = this.orderInfoData.totalGoodsNum;
                this.totalEstimateFee = this.orderInfoData.totalEstimateFee;
                this.orderTime = this.$common.retainTimeMinute(this.orderInfoData.orderTime);
                this.finishTime = this.$common.retainTimeMinute(this.orderInfoData.finishTime);
                this.validCode = this.orderInfoData.validCode;
                this.pid = this.orderInfoData.pid;
                this.skuImg = this.orderInfoData.skuImg;

                if(this.skuImg){
                    this.left_span = 7;
                    this.right_span = 17;
                    this.right_padding_left = "8px";
                }else{
                    this.left_span = 0;
                    this.right_span = 24;
                    this.right_padding_left = "0px";
                }

                this.showEstimateFee = this.orderInfoData.showEstimateFee;
            }
        },

        methods:{
            topClick(){
                this.$emit("topClick");
            },
            bottomClick(){
                this.$emit("bottomClick");
            },
            //
            // /**
            //  * 是否显示佣金数据
            //  */
            // isShowEstimateFee(){
            //     if(this.orderInfoData){
            //         this.ext1_user = this.orderInfoData.ext1_user;
            //         let phone = this.$store.state.userPhone;
            //         if(this.ext1_user && phone && this.ext1_user === phone){
            //             return false;
            //         }
            //     }
            //     return true;
            // },

        }
    }
</script>

<style scoped>
    .goods_name_div {
        /*!*设置文字超出部分省略号*!*/
        overflow: hidden;
        text-overflow: ellipsis;
        /*white-space: nowrap;*/
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        color: #555555;
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 5px;
    }

</style>